import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {MyPayRequest} from "../models/MyPayRequest";
import {PaymentTransactionRequest} from "../models/paymentTransactionRequest";
import {PaymentMethod} from "../enums/paymentMethod";
import {PaymentTransactionResponse} from "../interface/paymentTransactionResponse";
import {PaymentTransactionService} from "./payment-transaction.service";
import {UserCardResponse} from "../interface/userCardResponse";

@Injectable({
  providedIn: "root"
})
export class MyPayService {

  private readonly ENDPOINT_URL = `${environment.apiUrl}/my-pay`;

  constructor(
    private http: HttpClient,
    private paymentTransaction: PaymentTransactionService
  ) {
  }

  initPayment(transactionAmount: string, userCard: UserCardResponse, isCommissionActive: boolean) {
    const issuerId: string = crypto.randomUUID();
    const description: string = "Transfer money to user";

    const paymentTransactionRequest = this.prepareTransactionRequest({
      description,
      issuerId,
      transactionAmount,
      userCard,
      moneyLuxUuid: null
    });

    this.paymentTransaction.create(paymentTransactionRequest, isCommissionActive).subscribe({
      next: (response: PaymentTransactionResponse) => {
        const myPayLinkRequest = new MyPayRequest(response.issuerId, response.amount)
        this.getMyPayPaymentOperationsLink(myPayLinkRequest).subscribe(redirectLink => {
          window.location.href = redirectLink;
        });
      }
    })
  }

  initForProductBuying(transactionAmount: number, orderId: number) {
    const issuerId: string = crypto.randomUUID();
    const description: string = 'Product buying';

    const paymentTransactionRequest = this.prepareTransactionRequest({
      description,
      issuerId,
      transactionAmount,
      orderId
    });

    this.paymentTransaction.create(paymentTransactionRequest, false).subscribe({
      next: (response: PaymentTransactionResponse) => {
        const myPayLinkRequest = new MyPayRequest(response.issuerId, response.amount)
        this.getMyPayPaymentOperationsLink(myPayLinkRequest).subscribe(redirectLink => {
          window.location.href = redirectLink;
        });
      }
    });
  }

  getMyPayPaymentOperationsLink(myPayLinkRequest: MyPayRequest): Observable<string> {
    const url = `${this.ENDPOINT_URL}/payment-options-link`;
    return this.http.post(url, myPayLinkRequest, {responseType: 'text'});
  }

  private prepareTransactionRequest(params: {
    description: string,
    issuerId: string,
    transactionAmount: number | string,
    userCard?: UserCardResponse | null,
    moneyLuxUuid?: string | null,
    orderId?: number | null
  }): PaymentTransactionRequest {
    return new PaymentTransactionRequest(
      PaymentMethod.MY_PAY,
      params.description,
      params.userCard ? params.userCard.userId : null,
      params.issuerId,
      Number(params.transactionAmount),
      1,
      params.userCard ? params.userCard.cardId : null,
      0,
      params.moneyLuxUuid ?? null,
      params.orderId ?? null
    );
  }
}
